import React, { FunctionComponent } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { History } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import Routes from './routes/Routes';

const Root: FunctionComponent<RootProps> = (props) => {
    const { store, history } = props;
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Routes />
            </ConnectedRouter>
        </Provider>
    );
};

export default Root;
interface RootProps {
    store: Store;
    routes: React.ComponentType;
    history: History;
}
